import { action, computed, observable } from 'mobx';

import { TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR } from '../constants/apiUrls/apiUrls';
import forResponse from '../utils/forResponse';
import http from '../services/http';


class FanclubPackageStore {
  @observable fanclubPackage = null;

  @computed get fanclubPackagePrice() {
    return this.fanclubPackage;
  }

  fetchFanclubPriceForAnchor = (anchorId) => {
    const URL = TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR.replace('{anchorId}', encodeURIComponent(anchorId));

    return forResponse(http.get(URL));
  };

  @action async getFanclubSubscriptionPackage(anchorId) {
    const { data, error } = await this.fetchFanclubPriceForAnchor(anchorId);
    const { price } = data?.data || {};

    if (!error) {
      this.fanclubPackage = `$${price}`;
    } else {
      this.fanclubPackage = '';
    }

  }
}

export default new FanclubPackageStore();
